import { StatusBlock, StatusBlockType } from "@components/status-block";
import { formatRubles } from "@helpers/format";
import classNames from "classnames";
import { useMemo } from "react";
import styles from "./card.module.scss";

type Props = {
  className?: string;
  name: string;
  balance?: number;
  bankName: string;
  active: boolean;
  atWork: boolean;
  deleted: boolean;
  number?: string;
  scheduledActive?: boolean;
  tooltip?: string;
};

export const Card = ({
  active,
  atWork,
  balance,
  bankName,
  deleted,
  name,
  number,
  className,
  scheduledActive,
  tooltip,
}: Props) => {
  const status = useMemo(() => {
    if (deleted) {
      return <StatusBlock text="В архиве" type={StatusBlockType.Error} />;
    }

    let activeStatus;

    if (!active) {
      activeStatus = (
        <StatusBlock
          text="Не проверен"
          type={StatusBlockType.Error}
          hint={tooltip || "Необходима проверка реквизита"}
        />
      );
    } else if (!atWork) {
      activeStatus = (
        <StatusBlock
          text="Не активен"
          type={StatusBlockType.Warning}
          hint={tooltip || "Необходимо включить реквизит вручную"}
        />
      );
    } else if (!scheduledActive) {
      activeStatus = (
        <StatusBlock
          text="Активен"
          type={StatusBlockType.Orange}
          hint={tooltip || "Реквизит активен по расписанию"}
        />
      );
    } else {
      activeStatus = (
        <StatusBlock text="В работе" type={StatusBlockType.Success} hint={tooltip} />
      );
    }

    return (
      <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
        {activeStatus}
      </div>
    );
  }, [active, atWork, deleted, scheduledActive, tooltip]);

  return (
    <div className={classNames(styles.card, className)}>
      <div className={styles.cardHeader}>
        {status}
        <span className={styles.name}>{name}</span>
      </div>
      <span className={styles.phone}>{number}</span>
      <div className={styles.cardFooter}>
        <div>
          <p className={styles.title}>Оборот</p>
          <p className={styles.balance}>{formatRubles(balance || 0)}</p>
        </div>
        <div className={styles.bank}>
          <p className={styles.title}>Банк</p>
          <p className={styles.bankName}>{bankName}</p>
        </div>
      </div>
    </div>
  );
};
